import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import './styles.scss';

import {initAuthAction} from '../../actions/index';

import mapFormElementsToNameValues from '../../utils/mapFormElementsToNameValues';
import getRollString from '../../api/getRollString';
import strings from '../../utils/strings';
import Sidebar from '../../components/Sidebar';

class Enrollment extends React.Component {
	constructor() {
		super();

		this.state = {
			hasSentEmail: false,
			createUserError: null,
			registerBoxHeight: undefined,
		};

		this.updateRegisterBoxHeight = this.updateRegisterBoxHeight.bind(this);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
	}

	componentDidMount() {
		setTimeout(this.updateRegisterBoxHeight, 1000);
	}

	updateRegisterBoxHeight() {
		if (!this.refs.registerBox) {
			return;
		}

		const dimensions = this.refs.registerBox.getBoundingClientRect();

		this.setState({
			registerBoxHeight: dimensions.height,
		});
	}

	handleFormSubmit(event) {
		event.preventDefault();

		const form = event.target;
		const adminInfo = mapFormElementsToNameValues(form.elements);

		this.setState(
			{
				createUserError: null,
				hasSentEmail: false,
			},
			this.updateRegisterBoxHeight
		);

		getRollString(adminInfo)
			.then(() => {
				this.setState(
					{
						hasSentEmail: true,
						createUserError: null,
					},
					this.updateRegisterBoxHeight
				);
			})
			.catch((response) => {
				response.json().then((error) => {
					let createUserError = strings.message_user_status_error;

					if (error.error === 'already registered') {
						createUserError = error.hasOwnProperty('methods')
							? strings.formatString(
									strings.message_user_already_registered,
									error.methods[0]
								)
							: strings.message_try_logging_in;
					} else if (error.error === 'not found') {
						createUserError = strings.message_user_not_found;
					} else if (error.error === 'trial expired') {
						createUserError = strings.message_trial_period_expired;
					} else if (error.error === 'not approved') {
						createUserError = strings.message_not_yet_approved;
					}

					this.setState(
						{
							createUserError,
						},
						this.updateRegisterBoxHeight
					);
				});
			});
	}

	render() {
		const {registerBoxHeight, hasSentEmail, createUserError} = this.state;
		const {error} = this.props;

		const isLoginPage =
			window.location.pathname === '/enrollment' ||
			window.location.pathname === '/';

		return (
			<div className="lit-registration-view">
				<Sidebar isLoginPage={isLoginPage} />

				<div className="lit-view__content">
					<div className="lit-login">
						<div
							className="lit-login__wrapper lit-login__wrapper--dark"
							ref="registerBox"
						>
							<div
								className="lit-register__bg bg-primary"
								style={{
									height: registerBoxHeight,
									backgroundColor: 'white',
									borderRadius: '25px',
								}}
							/>

							<div className="lit-register__fg">
								{!createUserError && (
									<h1
										className="lit-login__header"
										style={{color: 'orange'}}
									>
										{hasSentEmail
											? strings.success
											: strings.registrationStatus}
									</h1>
								)}

								{createUserError && (
									<h1 className="lit-login__header">
										{strings.registration_Status}
									</h1>
								)}

								{!createUserError && !hasSentEmail && (
									<p className="lit-login__description">
										{strings.message_check_user_status}
									</p>
								)}

								{!createUserError && hasSentEmail && (
									<p className="lit-login__description">
										{strings.info_registration_email_sent}
									</p>
								)}

								{createUserError && (
									<p className="lit-login__description">
										{createUserError}
									</p>
								)}

								{!hasSentEmail && !createUserError && (
									<div className="lit-register__expanded">
										<form
											className="lit-login__form"
											onSubmit={this.handleFormSubmit}
										>
											<label
												className="lit-login__form__label"
												htmlFor="newUser-email"
											>
												{strings.email}
											</label>

											<input
												autoFocus
												className="lit-login__form__input"
												id="newUser-email"
												name="email"
												required
												type="email"
											/>

											<br />

											<button className="lit-btn bg-tertiary">
												{strings.checkStatus}
											</button>
										</form>
									</div>
								)}

								{createUserError && (
									<div className="lit-login__action-wrapper">
										<button
											className="lit-btn bg-tertiary"
											onClick={() => {
												this.setState(
													{
														createUserError: null,
														hasSentEmail: false,
													},
													this.updateRegisterBoxHeight
												);
											}}
										>
											{strings.tryAgain}
										</button>
									</div>
								)}
							</div>
						</div>

						{error && (
							<p>
								<strong>{error}</strong>
							</p>
						)}
					</div>
				</div>
			</div>
		);
	}
}

Enrollment.propTypes = {
	error: PropTypes.string.isRequired,
	iframeUrl: PropTypes.string.isRequired,
	initAuth: PropTypes.func.isRequired,
	isInit: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
	const {error, iframeUrl, isInit} = state.auth;

	return {
		error,
		iframeUrl,
		isInit,
	};
};

const mapDispatchToProps = {
	initAuth: initAuthAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Enrollment);
